var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemafix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.5A2.5 2.5 0 0 1 9.5 0h5A2.5 2.5 0 0 1 17 2.5V4h2a1 1 0 0 1 0 2h-2v3h2a1 1 0 1 1 0 2h-2v3h2a1 1 0 1 1 0 2h-2v1.5a2.5 2.5 0 0 1-2.5 2.5H13v3h-2v-3H9.5A2.5 2.5 0 0 1 7 17.5V16H5a1 1 0 1 1 0-2h2v-3H5a1 1 0 1 1 0-2h2V6H5a1 1 0 0 1 0-2h2V2.5ZM9 3v14a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Zm3 3.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 16.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemafix);
export default __webpack_public_path__ + "static/media/semafix.c139aa78295ee876c01b5009e89ecea6.svg";
export { ForwardRef as ReactComponent };